export default "__VITE_ASSET__CwR6qeA$__"